import { ExitReason, FetchFoodTrayTemplatesFilters, FoodTray, FoodTrayTemplate, FoodType } from '../../models';
import { FoodTrayTemplatesService } from '../../services';
import { ActionType } from './types';

export const getFoodTrayTemplates = (filters: FetchFoodTrayTemplatesFilters) => ({
  type: ActionType.GET_FOOD_TRAY_TEMPLATES,
  payload: FoodTrayTemplatesService.getFoodTrayTemplates(filters),
});
export const getFoodTrayTemplate = (id: string) => ({
  type: ActionType.GET_FOOD_TRAY_TEMPLATE,
  payload: FoodTrayTemplatesService.getFoodTrayTemplate(id),
});
export const clearFoodTrayTemplate = () => ({
  type: ActionType.CLEAR_FOOD_TRAY_TEMPLATE,
  payload: {},
});
export const duplicateFoodTrayTemplate = (id: string) => ({
  type: ActionType.DUPLICATE_FOOD_TRAY_TEMPLATE,
  payload: FoodTrayTemplatesService.duplicateFoodTrayTemplate(id),
});
export const createFoodTrayTemplate = (template: Partial<FoodTrayTemplate>) => ({
  type: ActionType.CREATE_FOOD_TRAY_TEMPLATE,
  payload: FoodTrayTemplatesService.createFoodTrayTemplate(template),
});
export const updateFoodTrayTemplate = (id: string, template: Partial<FoodTrayTemplate>) => ({
  type: ActionType.UPDATE_FOOD_TRAY_TEMPLATE,
  payload: FoodTrayTemplatesService.updateFoodTrayTemplate(id, template),
});
export const deleteFoodTrayTemplate = (id: string) => ({
  type: ActionType.DELETE_FOOD_TRAY_TEMPLATE,
  payload: FoodTrayTemplatesService.deleteFoodTrayTemplate(id),
});

//  ===== gastronom actions =====

// start a timer
export const startTimer = (foodTray: FoodTray) => ({
  type: ActionType.START_TIMER,
  payload: FoodTrayTemplatesService.startTimer({
    foodTray: { id: foodTray.id } as FoodTray,
    overrideFoodType: null,
    enteredAt: new Date().toISOString(),
  }),
});
export const startTimerForExistingFoodItem = (foodTray: FoodTray) => ({
  type: ActionType.START_TIMER_FOR_EXISTING_FOOD_ITEM,
  payload: FoodTrayTemplatesService.startTimerForExistingFoodItem({
    foodTray: { id: foodTray.id } as FoodTray,
    id: foodTray.foodItem.id,
    enteredAt: new Date().toISOString(),
  }),
});
// replace a food item
export const replaceFoodItem = (foodTray: FoodTray, overrideFoodType: FoodType) => ({
  type: ActionType.REPLACE_FOOD_ITEM,
  payload: FoodTrayTemplatesService.replaceFoodItem({
    foodTray: { id: foodTray.id } as FoodTray,
    overrideFoodType,
  }),
});
export const replaceFoodItemAndStartTimer = (foodTray: FoodTray, overrideFoodType: FoodType, exitReason?: ExitReason) => ({
  type: ActionType.REPLACE_FOOD_ITEM_AND_START_TIMER,
  payload: FoodTrayTemplatesService.replaceFoodItem({
    foodTray: { id: foodTray.id } as FoodTray,
    overrideFoodType,
    enteredAt: new Date().toISOString(),
    exitReason,
  }),
});
export const emptyFoodTray = (foodTray: FoodTray, exitReason: ExitReason) => ({
  type: ActionType.EMPTY_ITEM,
  payload: FoodTrayTemplatesService.emptyFoodTray(foodTray, exitReason),
});
export const emptyFoodLine = (id: string) => ({
  type: ActionType.EMPTY_LINE,
  payload: FoodTrayTemplatesService.emptyFoodLine(id),
});
